import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { apiConfig } from '@/config/api';
import { useGetAccount } from '@/modules/Customer/http/client/useGetAccount';
import { useGetAllPlannings } from './getAllPlannings';

export const useGetFinancialPlaningPermissions = () => {
  const { data = { document: '' } } = useGetAccount();
  const { data: financialPlaning = null } = useGetAllPlannings();
  return useQuery({
    queryKey: ['financial-planing', 'permissions'],
    queryFn: getFinancialPlaningPermissions,
    enabled: !!data.document,
    select: (response) => {
      if (financialPlaning) return { canAccess: true };
      if (!response.length) return { canAccess: true };

      return {
        canAccess: response.includes(data.document.replaceAll('.', '')),
      };
    },
  });
};

const getFinancialPlaningPermissions = async () => {
  const { data } = await axios.get<Response>(
    apiConfig.routes.financialPlanning.permissions
  );

  return data.customerCpf;
};

type Response = {
  customerCpf: string[];
};
